import {useEffect, useRef, useState} from "react";
import parse from 'html-react-parser';
import {mrbgStore} from "./mrbg/mrbgRedux";

function BlogContent({mainStyle}){

  const
    [contents] = useState( mrbgStore.getState().mrbgVars.content );

  return(
    <>
      {
        contents.map((cnt,k)=>{
          return(
            cnt.type == 'top'?
              <BCTop {...{...cnt,mainStyle}} key={k}/>:
              cnt.type == 'right'?
                <BCRight {...{...cnt,mainStyle}} key={k}/>:
                cnt.type == 'left'?
                  <BCLeft {...{...cnt,mainStyle}} key={k}/>:
                  cnt.type == 'back'?
                    <BCBack {...{...cnt,mainStyle}} key={k}/>:
                    ''
          )
        })
      }
    </>
  )
}
function BCTop({img,title,alt,description,mainStyle}){

  const
    smpCon = useRef(),
    [figPrlClass,setFigPrlClass] = useState(mainStyle.vPrl),
    [h2PrlClass,setH2PrlClass]   = useState(mainStyle.vPrl),
    [divPrlClass,setDivPrlClass] = useState(mainStyle.vPrl);

  function parallax(){
    smpCon?.current?.querySelector('figure').getBoundingClientRect().top < window.innerHeight?
      setFigPrlClass(''):
      setFigPrlClass(mainStyle.vPrl)

    smpCon?.current?.querySelector('h2').getBoundingClientRect().top < window.innerHeight?
      setH2PrlClass(''):
      setH2PrlClass(mainStyle.vPrl)

    smpCon?.current?.querySelector('div').getBoundingClientRect().top < window.innerHeight?
      setDivPrlClass(''):
      setDivPrlClass(mainStyle.vPrl)
  }

  useEffect(()=>{
    window.addEventListener('scroll',parallax);
    window.dispatchEvent(new Event('scroll'));
    return ()=> window.removeEventListener('scroll',parallax)
  },[])

  return(
    <section className={`${mainStyle.smpCon} ${mainStyle.topImg}`} ref={smpCon}>
      <figure className={figPrlClass}>
        <img src={`/img/${img}`} alt={alt} />
      </figure>
      <h2 className={h2PrlClass}>{title}</h2>
      <div className={divPrlClass}>{parse(description)}</div>
    </section>
  )
}
function BCRight({img,title,alt,description,mainStyle}){

  const lang = document.documentElement.getAttribute('lang').split('=')[0];
  if( ['ar','fa'].includes(lang) )
    return(
      <section className={`${mainStyle.smpCon} ${mainStyle.rightImg} ${mainStyle.flexRowDesk} ${mainStyle.prl_Y}`}>
        <figure className={mainStyle.sideImg}>
          <img src={`/img/${img}`} alt={alt} />
        </figure>
        <div className={mainStyle.sideTxt}>
          <h2>{title}</h2>
          <div>{parse(description)}</div>
        </div>
      </section>
    )
  else
    return(
      <section className={`${mainStyle.smpCon} ${mainStyle.rightImg} ${mainStyle.flexRowDesk} ${mainStyle.prl_Y}`}>
        <div className={mainStyle.sideTxt}>
          <h2>{title}</h2>
          <div>{parse(description)}</div>
        </div>
        <figure className={mainStyle.sideImg}>
          <img src={`/img/${img}`} alt={alt}/>
        </figure>
      </section>
    )
}
function BCLeft({img,title,alt,description,mainStyle}){

  const lang = document.documentElement.getAttribute('lang').split('=')[0];
  if( ['ar','fa'].includes(lang) )
    return (
      <section className={`${mainStyle.smpCon} ${mainStyle.leftImg} ${mainStyle.flexRowDesk} ${mainStyle.prl_Y}`}>
        <div className={mainStyle.sideTxt}>
          <h2>{title}</h2>
          <div>{parse(description)}</div>
        </div>
        <figure className={mainStyle.sideImg}>
          <img src={`/img/${img}`} alt={alt} />
        </figure>
      </section>
    )
  else
    return(
      <section className={`${mainStyle.smpCon} ${mainStyle.leftImg} ${mainStyle.flexRowDesk} ${mainStyle.prl_Y}`}>
        <figure className={mainStyle.sideImg}>
          <img src={`/img/${img}`} alt={alt}/>
        </figure>
        <div className={mainStyle.sideTxt}>
          <h2>{title}</h2>
          <div>{parse(description)}</div>
        </div>
      </section>
    )
}
function BCBack({img,title,description,mainStyle}){

  return (
    <section className={`${mainStyle.IBGFrame}`} style={{backgroundImage: `url('/img/${img}')`}}>
      <div className={mainStyle.IBG}>
        <h2>{title}</h2>
        <div>{parse(description)}</div>
      </div>
    </section>
  )
}
export default BlogContent;